/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';
import { LexplusUpdateAdminBenutzerAktivDto } from '../../models/lexplus-update-admin-benutzer-aktiv-dto';

export interface AdminBenutzerverwaltungControllerSetAktivV1$Params {
  id: string;
      body: LexplusUpdateAdminBenutzerAktivDto
}

export function adminBenutzerverwaltungControllerSetAktivV1(http: HttpClient, rootUrl: string, params: AdminBenutzerverwaltungControllerSetAktivV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, adminBenutzerverwaltungControllerSetAktivV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

adminBenutzerverwaltungControllerSetAktivV1.PATH = '/v1/benutzerverwaltung/{id}/aktiv';
